/* Knife ruler — reveals the knife tip-to-end with a live length readout as it scrolls into view. */
if (!customElements.get('knife-ruler')) {
  customElements.define('knife-ruler', class extends HTMLElement {
    connectedCallback() {
      this.cover = this.querySelector('[data-ruler-cover]');
      this.mark = this.querySelector('[data-ruler-mark]');
      this.readout = this.querySelector('[data-readout]');
      this.bladeLbl = this.querySelector('[data-blade-label]');
      this.handleLbl = this.querySelector('[data-handle-label]');
      this.blade = +this.dataset.blade || 208;
      this.handle = +this.dataset.handle || 135;
      this.J = (+this.dataset.split || 59.8) / 100;
      this.unit = this.dataset.unit || 'in';
      this.p = 0;

      if (document.documentElement.classList.contains('reduced-motion')) { this.render(1); return; }

      const clamp = x => Math.min(1, Math.max(0, x));
      const section = this.closest('section') || this;
      const tick = () => {
        const r = section.getBoundingClientRect();
        const target = clamp((innerHeight * 0.9 - r.top) / (innerHeight * 0.6));
        this.p += (target - this.p) * 0.12;
        this.render(this.p);
        this.raf = this.visible || Math.abs(target - this.p) > 0.001 ? requestAnimationFrame(tick) : 0;
      };
      this.io = new IntersectionObserver(([e]) => {
        this.visible = e.isIntersecting;
        if (this.visible && !this.raf) this.raf = requestAnimationFrame(tick);
      });
      this.io.observe(this);
    }

    disconnectedCallback() { this.io?.disconnect(); cancelAnimationFrame(this.raf); }

    mmAt(x) {
      return x <= this.J ? x / this.J * this.blade : this.blade + (x - this.J) / (1 - this.J) * this.handle;
    }

    render(x) {
      const pct = (x * 100).toFixed(2) + '%';
      if (this.cover) this.cover.style.left = pct;
      if (this.mark) { this.mark.style.left = pct; this.mark.style.opacity = x > 0.995 ? 0 : 1; }
      const mm = this.mmAt(Math.min(1, x));
      if (this.readout) this.readout.textContent = this.unit === 'mm' ? `${Math.round(mm)}mm` : `${(mm / 25.4).toFixed(1)} in`;
      this.bladeLbl?.classList.toggle('is-shown', x >= this.J);
      this.handleLbl?.classList.toggle('is-shown', x >= 0.995);
    }
  });
}
